import { safeApiRequest } from './apiClient';

/**
 * Cihaz değişimi listesi
 */
export const fetchCihazDegisimleri = async ({ tab = 'onay-bekleyen', sayfa = 1, limit = 20 } = {}) => {
  const query = { tab, sayfa, limit };
  const response = await safeApiRequest('/api/cihaz-degisimleri', {
    method: 'GET',
    query,
    skipCsrf: true,
  });
  return response;
};

/**
 * Cihaz değişimi için uygun randevular (sadece Randevu Tamamlandı)
 */
export const fetchCihazDegisimiRandevulari = async ({
  arama = '',
  sayfa = 1,
  limit = 5,
} = {}) => {
  const query = { sayfa, limit };
  const q = String(arama || '').trim();
  if (q) query.arama = q;
  const response = await safeApiRequest('/api/cihaz-degisimleri/randevular', {
    method: 'GET',
    query,
    skipCsrf: true,
  });
  return response;
};

/**
 * Cihaz değişimi detayı
 */
export const fetchCihazDegisimiDetay = async (id) => {
  const response = await safeApiRequest(`/api/cihaz-degisimleri/${id}`, {
    method: 'GET',
    skipCsrf: true,
  });
  return response;
};

/**
 * Cihaz değişimi talebi oluştur
 */
export const createCihazDegisimi = async (payload) => {
  const response = await safeApiRequest('/api/cihaz-degisimleri', {
    method: 'POST',
    body: payload,
  });
  return response;
};

/**
 * Cihaz değişimini onayla
 */
export const onaylaCihazDegisimi = async (id) => {
  const response = await safeApiRequest(`/api/cihaz-degisimleri/${id}/onayla`, {
    method: 'PATCH',
    skipCsrf: true,
  });
  return response;
};

/**
 * Cihaz değişimini iptal et
 */
export const iptalCihazDegisimi = async (id) => {
  const response = await safeApiRequest(`/api/cihaz-degisimleri/${id}/iptal`, {
    method: 'PATCH',
    skipCsrf: true,
  });
  return response;
};

/**
 * Cihaz değişimine bağlı siparişi getir
 */
export const fetchCihazDegisimiSiparisi = async (cihazDegisimiId) => {
  const response = await safeApiRequest(`/api/cihaz-degisimleri/${cihazDegisimiId}/siparis`, {
    method: 'GET',
    skipCsrf: true,
  });
  return response;
};
